'use strict';

const React = require('react');

const PropTypes = require('prop-types');

// Stores
const ItemStore = require('../../stores/ItemStore.es');
const PriceStore = require('../../../global/stores/PriceStore.es.js');
const TourStore = require('../../../components/Tour/TourStore');

// Components
const Tour = require('../../../components/Tour/Tour');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const SV = require('server-vars');
const {type: { TRADE_TOUR, REQUEST_ITEM_HOLD_TOUR }} = TourStore;
const tourTracking = require('../../../global/tracking/tourTracking');
const ArrowRightIcon = require('dibs-vg/dist/react/arrow-right');

const ContactDealerSidebar = ({copy, onContactDealer, tradeTour, requestItemHoldTour}) => {
    return (
        <div className="pdp-sidebar-contact-dealer">
            <Tour step={1} dataTn="contact-dealer-request-hold" {...requestItemHoldTour}>
                <Tour step={2} dataTn="contact-dealer-trade" {...tradeTour}>
                    <a href="#0" className="pdp-sidebar-contact-dealer-copy" onClick={onContactDealer}>
                        {copy} <ArrowRightIcon className="pdp-sidebar-contact-dealer-icon" />
                    </a>
                </Tour>
            </Tour>
        </div>
    );
};

ContactDealerSidebar.propTypes = {
    onContactDealer: PropTypes.func.isRequired,
    copy: PropTypes.string.isRequired,
    tradeTour: PropTypes.object,
    requestItemHoldTour: PropTypes.object,
    callout: PropTypes.object
};


module.exports = provideContext(connectToStores(
    ContactDealerSidebar,
    [
        ItemStore,
        PriceStore,
        TourStore
    ],
    context => {
        const itemStore = context.getStore(ItemStore);
        const priceStore = context.getStore(PriceStore);
        const tourStore = context.getStore(TourStore);
        const item = itemStore.getItem();
        const processedPriceData = priceStore.processPrice(item);

        return ({
            requestItemHoldTour: {
                type: REQUEST_ITEM_HOLD_TOUR,
                copy: SV.get(`tourCopy.${REQUEST_ITEM_HOLD_TOUR}`),
                isTourOpen: tourStore.isTourOpen(REQUEST_ITEM_HOLD_TOUR),
                currentStep: tourStore.getCurrentStep(REQUEST_ITEM_HOLD_TOUR),
                totalSteps: tourStore.getTotalSteps(REQUEST_ITEM_HOLD_TOUR),
                onCtaClick: tourTracking.trackCta,
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose
            },
            tradeTour: {
                type: TRADE_TOUR,
                subType: processedPriceData.priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
                copy: SV.get(`tourCopy.${TRADE_TOUR}`),
                isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
                currentStep: tourStore.getCurrentStep(TRADE_TOUR),
                totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose
            }
        });
    }
));



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerSidebar.jsx